/**
 * Copyright IBM Corp. 2022, 2026
 */

import type { FullWidthVideoFieldsFragment } from 'types/dato'
import { Layout } from 'components/materia/layout'
import Video from '../video'
import s from './style.module.css'

const FullWidthVideo = ({ layout, videoUrl }: FullWidthVideoFieldsFragment) => {
	return (
		<Layout layout={layout}>
			<div className={s.root}>
				<div className={s.videoWrapper}>
					<Video url={videoUrl} />
				</div>
			</div>
		</Layout>
	)
}

export default FullWidthVideo
